import { useRecoilState } from 'recoil';
import {
  FilteredLevels,
  FilteredRoles,
  FilteredSigungus,
  FilteredStacks,
} from '@/src/store/superstack/jobs/FilterStates';
import { useStaticData } from '@/src/utils/hooks/superstack/useStaticData';
import { useState } from 'react';
import { ChipClose } from '@/src/component/superstack/base/Chip';
import StackImage from '@/src/component/superstack/stacks/StackImage';

const ChipFilterContainer = ({ type, isMobile, cx, mcx, ...props }) => {
  const [filteredStacks, setFilteredStacks] = useRecoilState(FilteredStacks);
  const [filteredRoles, setFilteredRoles] = useRecoilState(FilteredRoles);
  const [filteredLevels, setFilteredLevels] = useRecoilState(FilteredLevels);
  const [filteredSigungus, setFilteredSigungus] = useRecoilState(FilteredSigungus);
  const {
    roles: staticRoles = [],
    levels: staticLevels = [],
    stacks: stataicStacks = [],
  } = useStaticData();

  let stacks = [],
    roles = [],
    levels = [],
    sigungus = [];
  let needRendering = false;
  switch (type) {
    case 'stack':
      stacks = Object.keys(filteredStacks);
      needRendering = stacks.length > 0;
      break;
    case 'role':
      roles = filteredRoles;
      needRendering = roles.length > 0;
      break;
    case 'level':
      levels = filteredLevels;
      needRendering = levels.length > 0;
      break;
    case 'sigungu':
      sigungus = filteredSigungus;
      needRendering = sigungus.length > 0;
      break;
    case 'all':
    default:
      stacks = Object.keys(filteredStacks);
      roles = filteredRoles;
      levels = filteredLevels;
      sigungus = filteredSigungus;
      needRendering =
        stacks.length > 0 || roles.length > 0 || levels.length > 0 || sigungus.length > 0;
  }

  const [checkIsAllSelectedSido, setCheckIsAllSelectedSido] = useState([]);

  if (!needRendering) {
    return null;
  }

  const excludeStack = (flag) => {
    const newFilteredStacks = { ...filteredStacks };
    delete newFilteredStacks[flag];
    setFilteredStacks(newFilteredStacks);
  };
  const excludeRole = (val) => {
    setFilteredRoles(
      filteredRoles.filter((role) => {
        return role !== val;
      }),
    );
  };
  const excludeLevel = (val) => {
    setFilteredLevels(
      filteredLevels.filter((level) => {
        return level !== val;
      }),
    );
  };

  const excludeSigungu = (val) => {
    const sigunguSplit = val.split(';');
    if (sigunguSplit[1] === '전체') {
      setFilteredSigungus(
        filteredSigungus.filter((sidoSigungu) => {
          return sidoSigungu.split(';')[0] !== sigunguSplit[0];
        }),
      );
      setCheckIsAllSelectedSido(
        checkIsAllSelectedSido.filter((sidoSigungu) => {
          return sidoSigungu.split(';')[0] !== sigunguSplit[0];
        }),
      );
    } else {
      setFilteredSigungus(
        filteredSigungus.filter((sidoSigungu) => {
          return sidoSigungu !== val;
        }),
      );
    }
  };

  const ChipFilter = ({ mode, size, text, handleClick, ...props }) => {
    return (
      <span className={cx('chip')} onClick={handleClick}>
        <ChipClose mode={mode} size={size} {...props}>
          {text}
        </ChipClose>
      </span>
    );
  };
  const StackChipFilter = ({ mode, size, flag, name, handleClick, ...props }) => {
    return (
      <span className={cx('chip')} onClick={handleClick}>
        <ChipClose mode={mode} size={size} {...props}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <StackImage
              alt="스택 이미지"
              flag={flag}
              width={16}
              height={16}
              layout="fixed"
              priority={true}
            />
            <span>{name}</span>
          </div>
        </ChipClose>
      </span>
    );
  };
  return (
    <div className={isMobile ? mcx(['chips']) : cx(['chips', 'row'])} {...props}>
      {stacks.map((flag) => {
        return (
          <StackChipFilter
            key={flag}
            mode="filled"
            size="lg"
            flag={flag}
            name={stataicStacks.find((staticStack) => staticStack.flag === flag)?.name}
            handleClick={(e) => {
              e.preventDefault();
              excludeStack(flag);
            }}
          />
        );
      })}
      {roles.map((role) => {
        return (
          <ChipFilter
            key={role}
            mode="filled"
            size="lg"
            text={staticRoles.find((staticRoles) => staticRoles[0] === role)?.[1]}
            handleClick={(e) => {
              e.preventDefault();
              excludeRole(role);
            }}
          />
        );
      })}
      {levels.map((level) => {
        return (
          <ChipFilter
            key={level}
            mode="filled"
            size="lg"
            text={staticLevels.find((staticLevel) => staticLevel[0] === level)?.[1]}
            handleClick={(e) => {
              e.preventDefault();
              excludeLevel(level);
            }}
          />
        );
      })}
      {sigungus.map((sidoSigungu) => {
        const sigunguSplit = sidoSigungu.split(';');
        if (sigunguSplit[1] === '전체') {
          if (!checkIsAllSelectedSido.includes(sigunguSplit[0])) {
            setCheckIsAllSelectedSido(checkIsAllSelectedSido.concat(sigunguSplit[0]));
          }
          return (
            <div key={sidoSigungu}>
              <ChipFilter
                mode="filled"
                size="lg"
                text={sidoSigungu.replace(';', ' ')}
                handleClick={(e) => {
                  e.preventDefault();
                  excludeSigungu(sidoSigungu);
                }}
              />
            </div>
          );
        } else if (!filteredSigungus.includes(sigunguSplit[0] + ';전체')) {
          return (
            <div key={sidoSigungu}>
              <ChipFilter
                mode="filled"
                size="lg"
                text={sidoSigungu.replace(';', ' ')}
                handleClick={(e) => {
                  e.preventDefault();
                  excludeSigungu(sidoSigungu);
                }}
              />
            </div>
          );
        }
      })}
    </div>
  );
};

export { ChipFilterContainer };
